const html = require('choo/html')
const { Button, Input } = require('./elements.js')
const Logo = require('./logo.js')


module.exports = function SharingDialog(state, emit) {
  function agree() {
    emit('agreewithterms')
    emit('sharesamplepack')
  }
  if (!state.agreeWithTerms) {
    return html`
      <body>
        <div id="app">
          ${Logo()}
          <ul id="share-dialog" class="column space-small">
            <li>
              <p>
                Lorem responsible dolor sit amet, consectetur adipisicing elit,
                eiusmod tempor incididunt ut copyrights et dolore magna aliqua.
                Ut minim veniam, quis nostrud exercitation ullamco laboris nisi
                ut please ex ea consequences.
              </p>
            </li>
            <li>
              <div class="size-big controls">
                ${Button({ onClick: () => emit('stopsharing') }, "NOPE")}
                ${Button({ onClick: () => agree() }, "AGREE")}
              </div>
            </li>
          </ul>
        </div>
      </body>
    `
  } else if (state.uploading) {
    return html`
      <body>
        <div id="app">
          ${Logo()}
          <ul id="share-dialog" class="column space-small">
            <li><h1>Uploading...</h1></li>
          </ul>
        </div>
      </body>
    `
  } else if (state.sharedUrl) {
    return html`
       <body>
         <div id="app">
           ${Logo()}
           <ul id="share-dialog" class="column space-small">
            <li><img src="https://cdn.shopify.com/s/files/1/0162/8612/files/how_840x.jpg" alt="Playing with Makey Makey is fun!" /></li>
            <li class="size-big">
              ${Input({ value: state.sharedUrl })}
            </li>
            <li class="size-big controls">
              ${Button({ onClick: () => emit('stopsharing') }, "EXIT")}
              ${Button({ onClick: () => emit('copysharedurl') }, "COPY LINK")}
            </li>
           </ul>
         </div>
       </body>
     `
  }
}
